import React, { Component } from 'react';
import styled from 'styled-components';
import { changeLocation } from 'api/Location';

import Auth from '../../routes/Auth';

// Instructor demo walkthrough. Reachable from two places:
//   1. Onboarding path-choice, when the instructor picks "Demo".
//      user.onboard is still 0 in this case.
//   2. Welcome page, after onboarding is complete. user.onboard is 1.
//
// The self-contained HTML at /instructor-demo-flow.html is loaded
// in an iframe with ?onboarding=true|false so it can present the
// right end-of-demo buttons. Button clicks bubble up via
// postMessage and this container handles the redirects.

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #F4F6F8;
`;

const Frame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  display: block;
`;

class InstructorDemoPage extends Component {
  componentDidMount() {
    window.addEventListener('message', this.handleMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage);
  }

  handleMessage = (event) => {
    const data = event.data;
    if (!data || data.source !== 'instructor-demo') return;

    switch (data.type) {
      case 'done':
        changeLocation('/instructor/welcome');
        break;
      case 'setup':
        changeLocation('/instructor/onboarding/simulation-selection');
        break;
      case 'logout':
        if (Auth.isUserAuthenticated()) {
          Auth.deauthenticateUser();
        }
        changeLocation('/login');
        break;
      default:
        break;
    }
  };

  get onboardingComplete() {
    const user = Auth.getUser();
    return !!(user && user.onboard === 1);
  }

  render() {
    const src = `/instructor-demo-flow.html?onboarding=${this.onboardingComplete ? 'true' : 'false'}`;
    return (
      <Wrapper>
        <Frame src={src} title="Instructor demo walkthrough" />
      </Wrapper>
    );
  }
}

export default InstructorDemoPage;



// WEBPACK FOOTER //
// ./src/instructor/containers/demo.js